import { trackEvent } from 'services/Tatari';

export const trackPackageOrderComplete = ({
  directToCheckout,
  packageType,
  paymentTotal,
  orderNumber,
  userId
}) => {
  trackEvent('package_order_complete', {
    directToCheckout,
    packageType,
    paymentTotal,
    orderNumber,
    userId
  });
};
export const trackPackageCouponApplied = ({
  couponAmount,
  couponText,
  packageType,
  userId
}) => {
  trackEvent('package_coupon_applied', {
    couponAmount,
    couponText,
    packageType,
    userId
  });
};
export const trackPackageProjectStarted = ({
  budgetAnswer,
  designStyleAnswer,
  finishAnswer,
  reasonForDesign,
  spaceSelected,
  userId
}) => {
  trackEvent('package_project_started', {
    budgetAnswer,
    designStyleAnswer,
    finishAnswer,
    reasonForDesign,
    spaceSelected,
    userId
  });
};
export const trackDesignPackagesCTAClick = () => {
  trackEvent('start_project_clicked');
};
export const trackPackageSelectCTAClick = ({
  packageSku,
  packagePrice
}) => {
  trackEvent('package_selection', {
    packageSku,
    packagePrice
  });
};
